import { useBlockProps } from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";
import { useMemo, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import "../style.scss";

export default function Edit(props) {
  const { attributes, setAttributes, clientId } = props;
  const [displayState, setDisplayState] = useState("default");
  return (
    <>
      <AllInspectorSettings
        setAttributes={setAttributes}
        attributes={attributes}
        clientId={clientId}
        displayState={displayState}
        setDisplayState={setDisplayState}
      />
      <Content {...props} displayState={displayState} />
    </>
  );
}

export function Content(props) {
  const { context, attributes, displayState, clientId } = props;

  const {
    defaultText,
    addedText,
    defaultIcon,
    addedIcon,
    defaultStyles,
    hoverStyles,
    addedStyles,
    useIcon = true,
    iconGap = "4px",
    iconPosition = "left",
  } = attributes;

  const getDefaultBorderCSS = () => {
    if (
      !defaultStyles.borders ||
      Object.keys(defaultStyles.borders).length === 0
    ) {
      return {};
    }
    return {
      "--atc-border-color": defaultStyles.borders.color || "",
      "--atc-border-width": defaultStyles.borders.width || "",
      "--atc-border-style": defaultStyles.borders.style || "solid",
    };
  };

  const getAddedBorderCSS = () => {
    if (!addedStyles.borders || Object.keys(addedStyles.borders).length === 0) {
      return {};
    }
    return {
      "--atc-border-color-added": addedStyles.borders.color || "",
      "--atc-border-width-added": addedStyles.borders.width || "",
      "--atc-border-style-added": addedStyles.borders.style || "solid",
    };
  };

  const getHoverBorderCSS = () => {
    if (!hoverStyles.borders || Object.keys(hoverStyles.borders).length === 0) {
      return {};
    }
    return {
      "--atc-border-color-hover": hoverStyles.borders.color || "",
      "--atc-border-width-hover": hoverStyles.borders.width || "",
      "--atc-border-style-hover": hoverStyles.borders.style || "solid",
    };
  };

  const getDefaultStyles = useMemo(() => {
    let styles = {};
    if (defaultStyles.backgroundColor) {
      styles["--atc-background-color"] = defaultStyles.backgroundColor;
    }
    if (defaultStyles.textColor) {
      styles["--atc-text-color"] = defaultStyles.textColor;
    }
    return styles;
  }, [defaultStyles]);

  const getAddedStyles = useMemo(() => {
    let styles = {};
    if (addedStyles.backgroundColor) {
      styles["--atc-background-color-added"] = addedStyles.backgroundColor;
    } else if (defaultStyles.backgroundColor) {
      styles["--atc-background-color-added"] = defaultStyles.backgroundColor;
    }
    if (addedStyles.textColor) {
      styles["--atc-text-color-added"] = addedStyles.textColor;
    } else if (defaultStyles.textColor) {
      styles["--atc-text-color-added"] = defaultStyles.textColor;
    }
    return styles;
  }, [addedStyles, defaultStyles]);

  const getHoverStyles = useMemo(() => {
    let styles = {};
    if (hoverStyles.backgroundColor) {
      styles["--atc-background-color-hover"] = hoverStyles.backgroundColor;
    } else if (defaultStyles.backgroundColor) {
      styles["--atc-background-color-hover"] = defaultStyles.backgroundColor;
    }
    if (hoverStyles.textColor) {
      styles["--atc-text-color-hover"] = hoverStyles.textColor;
    } else if (defaultStyles.textColor) {
      styles["--atc-text-color-hover"] = defaultStyles.textColor;
    }
    return styles;
  }, [hoverStyles, defaultStyles]);

  const dataProps = {
    "data-product-id": context?.postId ?? "",
    className: `icon-${
      displayState === "default" ? defaultIcon.position : addedIcon.position
    } ${displayState === "added" ? "added" : ""}`,
    style: {
      ...getDefaultStyles,
      ...getAddedStyles,
      ...getHoverStyles,
      "--atc-icon-color": defaultStyles.textColor,
      "--atc-icon-color-hover": hoverStyles.textColor,
      "--atc-icon-gap": iconGap,
      "--atc-icon-position": iconPosition === "left" ? "row" : "row-reverse",
      "--atc-icon-color-added": addedStyles.textColor,
      ...(displayState === "default"
        ? getDefaultBorderCSS()
        : getAddedBorderCSS()),
      ...getHoverBorderCSS(),
    },
  };

  const blockProps = useBlockProps(dataProps);

  const displayIconHtml = useMemo(() => {
    let icon = defaultIcon;
    if (displayState === "added") {
      icon = addedIcon;
    }

    if (!useIcon || !icon.name || !icon.type) {
      return "";
    }

    try {
      let html = (
        <span
          className={`wp-block-brandy-add-to-compare-list-icon ${
            displayState === "added" ? "added-state" : "default-state"
          }`}
        >
          <i
            className={`ph${
              icon.type !== "regular" ? "-" + icon.type : ""
            } ph-${icon.name}`}
          ></i>
        </span>
      );
      return html;
    } catch (error) {
      console.error("Error generating icon HTML:", error);
      return "";
    }
  }, [displayState, defaultIcon, addedIcon, useIcon]);

  return (
    <div {...blockProps}>
      {displayIconHtml !== "" && displayIconHtml}

      {(defaultText || addedText) && (
        <div className="wp-block-brandy-add-to-compare-list-text-wrap">
          <span
            className={`wp-block-brandy-add-to-compare-list-text ${
              displayState === "default" ? "default-state" : "added-state"
            }`}
            dangerouslySetInnerHTML={{
              __html: displayState === "default" ? defaultText : addedText,
            }}
          ></span>
        </div>
      )}
    </div>
  );
}
